export enum HsTextureQuality {
  Low = 'Low',
  Medium = 'Medium',
  High = 'High',
  Highest = 'Highest',
}
